import styled from 'styled-components';
import { RatingWrapperProps } from '../../../Atoms/Rating';

import { commonStyles } from '../../../Atoms/Rating/Rating.styles';
import { Colors } from '../../../Foundation/Colors';

const inactiveStyle = (iconColor, highlightColor) => `
  svg{
    fill: ${Colors.white};
    stroke: ${iconColor};
  }
`;

const activeStyle = (iconColor, highlightColor) => `
  svg{
    fill: ${highlightColor};
    stroke: ${highlightColor};
  }
`;

export const RatingWrapper = styled.div<RatingWrapperProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .MuiRating-icon {
    ${({ iconColor, highlightColor }) =>
      inactiveStyle(iconColor, highlightColor)}
  }

  ${({ iconSize }) => commonStyles(iconSize)}

  .MuiRating-iconFilled {
    ${({ iconColor, highlightColor }) => activeStyle(iconColor, highlightColor)}
  }
`;
